module.exports = "<section class=section-content> <h1>Create a new fragment</h1> <p> Commonly used: <a href=#>organization</a>, <a href=#>person</a>, <a href=#>postaladdress</a> </p> <p class=inp-text> Search through types: <input type=text placeholder=\". . . . . . .\"> </p> </section>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Create.vue
 ** module id = 130
 ** module chunks = 0
 **/